<template>
  <main-template ref="main_template">
    <template v-slot:main>

      <div class="page_top" v-show="showPageContent">
        <h1 class="title">
          <span>{{name}}</span>
          <span v-if="productsData.products_count > 0" class="title_span">{{productsData.products_count}} товар</span>
        </h1>
        <bread-crumbs :navigation-data="navigationData"></bread-crumbs>
      </div>



      <div class="page_content" v-show="showPageContent" :class="[{block_user_actions: blockUserActions}]">
        <sub-sections
            v-if="subSectionsList.length > 0"
            @section_changed="section_changed($event)"
            :sub-sections-list="subSectionsList">
        </sub-sections>
        <div class="search-row" v-if="code == 'search'">
          <search-field v-if="false" type="catalog" placeholder="Найти"></search-field>
          <p
              v-if="code == 'search' &&
              (this.$route.query.q == 'undefined' || this.$route.query.q == '' || this.$route.query.q == null)"
              class="empty_request">
              Введите поисковый запрос и нажмите кнопку "Найти"
          </p>
          <p
              v-if="code == 'search' &&
              !(this.$route.query.q == 'undefined' || this.$route.query.q == '' || this.$route.query.q == null)
              && productsData?.list?.length == 0"
              class="empty_request">
              Сожалеем, но ничего не найдено.
          </p>
        </div>
        <filter-product
            :filter-data="filterData" :price-data="priceData"
            :sort-data="sortData"
            v-if="filterData != undefined"
        >
        </filter-product>
        <table-product v-if="productsData?.list?.length > 0" :products-data="productsData" @basket_changed="basket_changed_handler()"></table-product>
      </div>

    </template>
  </main-template>
</template>

<script>
// @ is an alias to /src
import MainTemplate from '@/components/MainTemplate.vue';
import BreadCrumbs from "@/components/share/BreadCrumbs";
import SubSections from "@/components/catalog/section/SubSections";
import FilterProduct from "@/components/catalog/section/FilterProduct";
import TableProduct from "@/components/catalog/section/TableProduct";
import axios from "axios";
import SearchField from "@/components/share/SearchField";

export default {
  name: 'CatalogSectionView',
  components: {
    SearchField,
    TableProduct,
    FilterProduct,
    SubSections,
    BreadCrumbs,
    MainTemplate,
  },
  data() {
    return{
      id : 0,
      name: null,
      code: null,
      section_products_count: 0,
      subSectionsList: [],
      navigationData: [],
      filterData : [],
      priceData : {
        "min_price" : null,
        "max_price" : null
      },
      sortData : {},
      productsData : [],

      showPageContent : false,

      blockUserActions: false
    }
  },
  mounted() {
    this.loadData(this.$route.params.section);
  },
  methods : {
    loadData : async function(section_code) {
      this.blockUserActions = true;

      this.$refs.main_template.active_preloader = true;

      let view_type = this.$route.query.view_type;
      let page = this.$route.query.page;
      let query = this.$route.query.q;
      let filter = this.$route.query.filter;
      let sort = this.$route.query.sort;
      let price = this.$route.query.price;

      let res = await axios.get(window.api_url + "catalog/section?code="
          + section_code
          + "&page=" + page + "&q=" + query
          + "&filter=" + filter + "&sort=" + sort
          + "&price=" + price
          + "&view_type=" + view_type
      );

      this.subSectionsList = res.data.data.sub_sections;
      this.id = res.data.data.id;
      this.name = res.data.data.name;
      this.code = res.data.data.code;
      this.section_products_count = res.data.data.section_products_count;

      this.navigationData = res.data.data.section_navigation;

      this.filterData = res.data.data.filter;

      this.priceData = res.data.data.price;

      this.sortData = res.data.data.sort;

      this.productsData = res.data.data;

      this.showPageContent = true;

      this.$refs.main_template.active_preloader = false;

      this.blockUserActions = false;
    },
    basket_changed_handler : function() {
      this.$refs.main_template.refreshHeader();
    }
  },
  watch: {
    '$route.query'() {
      let section_code = this.$route.params.section;
      let page = this.$route.query.page;

      console.log("section_code: " + section_code);
      console.log("page: " + page);

      this.loadData(section_code)
    }
  }
}
</script>

<style scoped>

.page_content.block_user_actions {
  pointer-events: none;
}

.search-row .empty_request {
  color: var(--Black, #222);
  font-family: Inter;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}



/*MOBILE*/
@media (max-width: 1250px)
{

}
</style>


